import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Dot04L"
);
